import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "types"
import { useApi } from "utils"

export const useDropdownDivisi = () => {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    api.get("/divisi/")
      .then((res: SuccessFetch<{ payload: { divisi_id: number, divisi_name: string }[] }>) => {
        setData(res.data.payload.map(item => {
          return {
            label: item.divisi_name,
            value: item.divisi_id.toString(),
          }
        }))
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false))

    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}


export const useDropdownDepartment = ({ divisi_id }: { divisi_id: number }) => {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(true)


  const fetching = () => {
    api.get(`/department/?divisi_id=${divisi_id}`)
      .then((res: SuccessFetch<{ payload: { department_id: number, department_name: string }[] }>) => {
        setData(res.data.payload.map(item => {
          return {
            label: item.department_name,
            value: item.department_id.toString(),
          }
        }))
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false))
  }

  const refecth = () => fetching()

  useEffect(() => {
    fetching()

    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [divisi_id])

  return { data, isLoading, refecth }
}